import { ImageUpload } from '#assets/svg';
import { useRecordImagesRecoil } from '#pages/DashboardChartForm/states/recordImagesState';
import isVideo from '#utils/isVideo';
import { produce } from 'immer';
import { useEffect, useState } from 'react';
import { FileUpload } from 'src/shared/components/file-upload/FileUpload';
import { useDraftChartForEdit } from '../useDraftChartForEdit';

export const DraftTotalExerciseMedia = ({}) => {
  const { draftChart } = useDraftChartForEdit();

  const [draftFileInfoList, setDraftFileInfoList] = useState<
    { id: string; url: string; type: 'videos' | 'images' }[]
  >([]);

  useEffect(() => {
    if (draftChart?.recordImages) {
      setDraftFileInfoList(
        draftChart.recordImages.map(fileInfo => ({
          id: fileInfo.id,
          url: fileInfo.resizedLink,
          type: isVideo(fileInfo.resizedLink) ? 'videos' : 'images'
        }))
      );
    }
  }, [draftChart]);

  const { setRecordImages } = useRecordImagesRecoil();

  const onUploadFileComplete = (id: string) => {
    setRecordImages(
      produce(draft => {
        draft.push(id);
      })
    );
  };

  const onRemoveFileComplete = (id: string) => {
    setRecordImages(
      produce(draft => {
        draft.filter(file => file !== id);
      })
    );
  };

  return (
    <FileUpload
      maxCountMsg={''}
      path={'exercise-image'}
      fileType={'.jpg,.jpeg,.png,.mp4,.mov,.svg'}
      // onChange={onChange}
      maxCount={5}
      onUploadFileComplete={onUploadFileComplete}
      onDeleteFileComplete={onRemoveFileComplete}
      defaultFileInfoList={draftFileInfoList}
    >
      <ImageUpload />
    </FileUpload>
  );
};
